import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PackageStatus } from 'src/app/api';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { makeHttpParams } from './utils';

/**
 * Objeto utilizado para buscas de devoluções
 */
export interface QueryReturnPackagesRequest {
  /**
   * Número máximo de resultados na busca. Se não informado, utiliza padrão `10`
   */
  limit: number;

  /**
   * Offset a ser utilizado na busca. Se não informado, utiliza padrão `0`
   */
  offset: number;

  /**
   * Campos para ordenar. Formato: `-campo` para descendente, `campo` ou `+campo` para ascendente
   */
  order?: string;

  /**
   * Possíveis situações da devolução
   */
  status?: ('DevolvidaParaRemetente'|'EmDevolucaoParaRemetente'|'Devolvida'|'EmDevolucao')[];

  /**
   * Código de rastreamento da remessa
   */
  trackingCode?: string;

  /**
   * Código de rastreamento da transportadora da remessa
   */
  carrierTrackingCode?: string;

  /**
   * Nome do destinatário
   */
  recipientName?: string;

  /**
   * Código de referência da remessa
   */
  referenceCode?: string;
}

export interface QueryReturnPackagesResponseItem {
  original: {
    id: string;
    referenceCode?: string;
    status: PackageStatus;
    trackingCode: string;
  };
  return?: {
    id: string;
    eventDescription?: string;
    expectedDelivery: Date;
    trackingCode: string;
    carrierTrackingCode: string;
  };
  recipient: {
    name: string;
    document: string;
    address: {
      city: string;
      country: string;
      district: string;
      number: string;
      postalCode: string;
      reference?: string;
      secondLine?: string;
      state?: string;
      street?: string;
    };
  };
}

export interface QueryReturnPackagesResponse {
  data: QueryReturnPackagesResponseItem[];
  count: number;
}

@Injectable()
export class ReturnPackageApiService {
  private apiUrl = environment.returnShippingApi;
  constructor(private http: HttpClient) {}

  public getReturnPackages(request?: Partial<QueryReturnPackagesRequest>): Observable<QueryReturnPackagesResponse> {
    return this.http.get<QueryReturnPackagesResponse>(`${this.apiUrl}/devolucoes`, {
      params: makeHttpParams(request),
      headers: {
        'Authorization': JSON.parse(localStorage.getItem('ls.token')),
      },
    });
  }
}
